import React from 'react';
import PropTypes from 'prop-types';
import { flatMap, forEach } from 'lodash';
import TableUtils from '../../../../../../../utils/TableUtils';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import TablePlain from "../../../../../../../components/table-plain/TablePlain";
import lstrings from '../../../../../../../utils/LStrings';
import { OverlayTrigger, Popover } from 'react-bootstrap';

class TableJubilaciones extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.processData(props.data.datos)
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: this.processData(nextProps.data.datos)
        });
    }

    processData = (data) => {
        if (data == null)
            return null;

        let info = {};
        let rowIndex = 0;

        forEach(data, (item) => {
            if (item.cuil === null)
                return;
            let cuil = item.cuil
            let cuilApo = item.cuilApo
            let sueldoBruto = item.sueldoBruto
            let sueldoNeto = item.sueldoNeto
            let titular = item.titular
            let apoderado = item.apoderado
            let periodo = item.periodo
            let rangoIngreso = item.rango

            if (!info[sueldoBruto]) {
                info[sueldoBruto] = {
                    id: rowIndex++,
                    cuil,
                    cuilApo,
                    sueldoBruto,
                    sueldoNeto,
                    titular,
                    apoderado,
                    periodo,
                    rangoIngreso,
                };
            }
        });

        let result = flatMap(info, (x) => x);

        return result;
    }

    expandedRow = (row) => {
        return (
			<TablePlain
				title={'Información de Apoderado'}
				columns={[
					'DNI / CUIT',
					'Nombre apoderado'
				]}
				rows={[(
					<tr key={0}>
						<td>
							{TableUtils.cuilFormat(row.cuilApo)}
						</td>
						<td>
							{TableUtils.stringFormat(row.apoderado)}
						</td>
					</tr>
				)]}
            />
        );
    };

    render() {
        return (
			<BootstrapTable
				data={this.state.data}
				expandableRow={() => true}
				expandComponent={this.expandedRow}
				options={TableUtils.defaultConfig()}>

				<TableHeaderColumn
					dataField="id"
					isKey
					width='30'
					dataFormat={TableUtils.plusButtonFormat}></TableHeaderColumn>
				<TableHeaderColumn
					dataField="cuil">{lstrings.cuit}</TableHeaderColumn>
				<TableHeaderColumn
					width='20%'
					dataField="titular" >{lstrings.nombre}</TableHeaderColumn>
				<TableHeaderColumn
					dataField="periodo"
					dataFormat={TableUtils.dateFormat}>{lstrings.periodo}</TableHeaderColumn>
				{
					this.props.rangoIngresos && <TableHeaderColumn
					dataFormat={(cell) => <OverlayTrigger
						trigger={["hover", "focus"]}
						placement="top"
						overlay={
							<Popover>
								<span>
									{this.props.rangoIngresos[cell]}
								</span>
							</Popover>
						}>
						<span>{cell}</span>
					</OverlayTrigger>}
					tdStyle={{
						cursor :'help'
					}}
					dataField="rangoIngreso"
                    /* dataFormat={TableUtils.ARSFormat} */>{lstrings.nivelIngreso}</TableHeaderColumn>
				}
            </BootstrapTable>
        );
    }
}

TableJubilaciones.propTypes = {
    data: PropTypes.any,
    onRequestInfo :PropTypes.func,
    hidePanels: PropTypes.any,
	rangoIngresos: PropTypes.object
};

export default TableJubilaciones;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableJubilaciones.js